import { CIcon } from '~/icons/types'
export const ciBicycleFrameVintage: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M7.687 16.16a3.137 3.137 0 1 1-2.94-4.22 2.908 2.908 0 0 1 .6.06 7.402 7.402 0 0 1 .76-.83 4.089 4.089 0 0 0-1.36-.23 4.14 4.14 0 1 0 4.03 5.05c-.35.07-.72.13-1.09.17Zm1.19-1.22a4.073 4.073 0 0 0-1.8-3.27s-.01-.02-.02-.02h-.01a.078.078 0 0 0-.04.04c-.24.22-.47.45-.68.68a3.143 3.143 0 0 1 1.56 2.71v.04a9.424 9.424 0 0 0 .99-.18ZM19.257 10.94a3.726 3.726 0 0 0-1.11.16l-.56-1.59-.79-2.22h1.16a.502.502 0 0 0 .45-.3l.38-.83a.486.486 0 0 0-.25-.66.496.496 0 0 0-.66.24l-.24.55h-1.55a.493.493 0 0 0-.47.66l.7 1.97.47 1.32.44 1.24a4.129 4.129 0 1 0 2.03-.54Zm0 7.28a3.136 3.136 0 0 1-1.69-5.78l1 2.81a.516.516 0 0 0 .47.33.467.467 0 0 0 .17-.03.493.493 0 0 0 .3-.64l-1.02-2.87a2.804 2.804 0 0 1 .77-.1 3.14 3.14 0 1 1 0 6.28Z',
      class: 'secondary'
    },
    {
      d:
        'M16.317 8.92a13.377 13.377 0 0 0-3.62-.36 10.445 10.445 0 0 0-3.8.73l-.35-.79-1.09-.01.54 1.24a9.237 9.237 0 0 0-1.58 1.17c-.02.02-.04.03-.06.05-.08.08-.17.14-.25.22a7.402 7.402 0 0 0-.76.83 5.784 5.784 0 0 0-1.07 1.79 1.864 1.864 0 0 0 .03 1.53 2.516 2.516 0 0 0 2.33.91 7.5 7.5 0 0 0 1.05-.07c.37-.04.74-.1 1.09-.17l.3-.06a8.143 8.143 0 0 0 .82-.21 1.17 1.17 0 0 0 .9.4 1.242 1.242 0 0 0 1.25-1.21 3.645 3.645 0 0 0 .82-.55 4.368 4.368 0 0 0 1.14-1.8 3.65 3.65 0 0 1 .63-1.18 3.685 3.685 0 0 1 2.15-1.14Zm-6.76 5.86c-.22.06-.45.12-.68.16a9.424 9.424 0 0 1-.99.18c-1.33.2-2.47.14-2.71-.28a1.06 1.06 0 0 1 .05-.73 5.739 5.739 0 0 1 1.1-1.74c.21-.23.44-.46.68-.68a.078.078 0 0 1 .04-.04h.01c.01 0 .02.02.02.02a11.643 11.643 0 0 1 1.6-.39l1.2 2.75a1.14 1.14 0 0 0-.32.75Zm3.52-2.59a3.462 3.462 0 0 1-.88 1.43 2.806 2.806 0 0 1-.51.36 1.264 1.264 0 0 0-.89-.37h-.01l-1.08-2.46a12.495 12.495 0 0 1 2.03-.04 13.935 13.935 0 0 1 1.72.22 5.673 5.673 0 0 0-.38.86Zm1.07-1.74a15.475 15.475 0 0 0-2.35-.34 13.758 13.758 0 0 0-2.4.06.418.418 0 0 0-.1.04l-.01-.03a.41.41 0 0 1 .11-.01 9.43 9.43 0 0 1 3.34-.61c.15-.01.3-.01.44-.01a12.547 12.547 0 0 1 2.03.17 4.067 4.067 0 0 0-1.06.73Z',
      class: 'main'
    },
    {
      d:
        'M9.557 8a.508.508 0 0 1-.5.5h-.51l-1.09-.01h-.61a.5.5 0 0 1 .01-1l2.2.01a.495.495 0 0 1 .5.5Z',
      class: 'secondary'
    },
    {
      d:
        'm9.287 10.18.01.03a.418.418 0 0 1 .1-.04.41.41 0 0 0-.11.01ZM7.077 11.67a.185.185 0 0 0-.07.02.078.078 0 0 1 .04-.04h.01c.01 0 .02.02.02.02Z',
      class: 'main'
    },
    {
      d: 'M9.397 10.17a.418.418 0 0 0-.1.04l-.01-.03a.41.41 0 0 1 .11-.01Z',
      class: 'main'
    }
  ],
  name: 'bicycle-frame-vintage',
  type: 'solid'
}
